import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-add-workorder',
  templateUrl: './add-workorder.component.html',
  styleUrls: ['./add-workorder.component.css']
})
export class AddWorkorderComponent implements OnInit {
  addworkform: FormGroup;
  constructor(private formBuilder: FormBuilder, private matdialogref:MatDialogRef<AddWorkorderComponent>) { }

  ngOnInit(): void {
    this.addworkform = this.formBuilder.group({
      wo_no: [""],
      actul_pricce: [""],
      work_no: [""],
      work_qty: [""],
      trip_book: [""],
      price_ton: [""],
      noti_radius: [""],
      
    })
  }
  close() {
    this.matdialogref.close()
  }
}
